import Datasource from './Datasource';
import { request } from 'd3';

/**
 *
 * This datasource set up a connection to a http server.
 * @export
 * @class HTTPDatasource
 * @extends {Datasource}

 */
export default class HTTPDatasource extends Datasource { }



// WEBPACK FOOTER //
// ./src/datasources/HTTPDatasource.ts